import React, { useRef } from "react";
import NavBar from "../NavBar/NavBar.tsx";
import Help from "../Help Section/Help.js";
import Footer from "../Footer/Footer.tsx";
import { useHistory } from "react-router-dom";
import { productbanner } from "../../Assets.tsx";
import OurProducts from "./OurProducts.tsx";
import ScrollToTopButton from "../Common-component/ScrollToTopButton.tsx";

/* Colours: text #4e5356 | buttons #2596be | headings #4573a6
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body) */

const highlights = [
  { title: "Concept to Launch", note: "Built around your business goals" },
  { title: "Scale & Perform", note: "Products made to grow with you" },
  { title: "Strategic Partner", note: "Support throughout your growth" },
];

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Ubuntu:wght@700&display=swap");

.pp{--text:#4e5356;--head:#4573a6;--btn:#2596be;--tint:#eef6fa;--line:#d3e4ed;
  position:relative;overflow:hidden;padding:150px 24px 90px;font-family:"Open Sans",sans-serif;font-weight:400;color:var(--text);
  background:#fff}
.pp>*{position:relative;z-index:1}
.pp::before{content:"";position:absolute;inset:0;pointer-events:none;background-image:radial-gradient(rgba(69,115,166,.12) 1.2px,transparent 1.2px);background-size:26px 26px;
  -webkit-mask-image:linear-gradient(180deg,#000,transparent 65%);mask-image:linear-gradient(180deg,#000,transparent 65%)}
.pp>*{position:relative;z-index:1}
.pp-in{display:flex;align-items:center;justify-content:space-between;gap:60px;max-width:1240px;margin:0 auto}

/* ---------- TEXT ---------- */
.pp-text{flex:1;min-width:0;max-width:600px;animation:ppL .9s cubic-bezier(.2,.8,.2,1) backwards}
.pp-chip{display:inline-block;margin-bottom:16px;padding:6px 18px;border-radius:50px;background:#fff;border:1px solid var(--line);
  color:var(--head);font-size:12px;letter-spacing:2px;text-transform:uppercase}
.pp h1{margin:0 0 16px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:42px;line-height:1.15;color:var(--head);cursor:default;transition:color .35s,letter-spacing .35s}
.pp h1:hover{color:var(--btn);letter-spacing:.6px}
.pp-line{display:flex;align-items:center;gap:12px;margin-bottom:20px}
.pp-line i{display:block;height:2px;width:40px;border-radius:2px;background:var(--btn)}.pp-line i:last-child{background:var(--head)}
.pp-text p{margin:0 0 16px;font-size:14.5px;line-height:1.75;color:var(--text)}
.pp-text p b{font-family:"Ubuntu",sans-serif;font-weight:700;color:var(--head)}

.pp-tags{display:flex;flex-wrap:wrap;gap:10px;margin:22px 0 30px}
.pp-tag{position:relative;overflow:hidden;z-index:0;padding:7px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);color:var(--head);
  font-size:14px;font-weight:600;cursor:default;transition:color .35s,border-color .35s,transform .35s cubic-bezier(.3,1.6,.5,1)}
.pp-tag::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateY(101%);transition:transform .4s cubic-bezier(.2,.8,.2,1)}
.pp-tag:hover{color:#fff;border-color:transparent;transform:translateY(-3px)}
.pp-tag:hover::before{transform:none}

/* button = same as .op-btn */
.pp-btn{position:relative;overflow:hidden;z-index:0;display:inline-flex;align-items:center;gap:8px;padding:12px 28px;border:none;border-radius:50px;
  background:var(--tint);color:var(--head);font-family:"Open Sans",sans-serif;font-weight:600;font-size:14px;cursor:pointer;box-shadow:0 0 0 1px var(--line) inset;
  transition:color .35s,transform .35s cubic-bezier(.3,1.6,.5,1),box-shadow .35s}
.pp-btn::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateX(-101%);transition:transform .45s cubic-bezier(.2,.8,.2,1)}
.pp-btn:hover{color:#fff;transform:translateY(-3px);box-shadow:0 16px 26px -12px rgba(37,150,190,.7)}
.pp-btn:hover::before{transform:none}
.pp-btn span{display:inline-block;transition:transform .35s}
.pp-btn:hover span{transform:translateX(5px)}

/* ---------- VISUAL ---------- */
.pp-vis{position:relative;flex:none;width:46%;max-width:540px;animation:ppR .9s .15s cubic-bezier(.2,.8,.2,1) backwards}
.pp-ring{position:absolute;inset:-14px;border-radius:44px;overflow:hidden}
.pp-ring::before{content:"";position:absolute;left:50%;top:50%;width:200%;height:200%;margin:-100% 0 0 -100%;
  background:conic-gradient(from 0deg,#4573a6,#2596be,#a9d3e6,#4573a6);animation:ppSpin 8s linear infinite}
.pp-ring::after{content:"";position:absolute;inset:4px;border-radius:40px;background:#eef6fa}
.pp-tilt{position:relative;padding:28px;border-radius:32px;background:#fff;border:1px solid var(--line);box-shadow:0 30px 50px -26px rgba(69,115,166,.6);
  transition:transform .15s ease-out;transform:perspective(900px) rotateX(0) rotateY(0)}
.pp-tilt img{display:block;width:100%;height:auto;object-fit:contain}
.pp-chipf{position:absolute;z-index:3;display:flex;align-items:center;gap:10px;padding:10px 16px;border-radius:16px;background:rgba(255,255,255,.96);backdrop-filter:blur(8px);
  border:1px solid var(--line);box-shadow:0 18px 30px -16px rgba(69,115,166,.55);font-size:13px;color:var(--text);white-space:nowrap}
.pp-chipf b{display:block;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:15px;color:var(--head)}
.pp-chipf .dot{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;background:linear-gradient(135deg,var(--head),var(--btn))}
.pp-chipf.c1{left:-34px;bottom:44px;animation:ppFloat 5s ease-in-out infinite}
.pp-chipf.c2{right:-24px;top:34px;animation:ppFloat 6s -2s ease-in-out infinite}

@keyframes ppL{from{opacity:0;transform:translateX(-70px)}}
@keyframes ppR{from{opacity:0;transform:translateX(70px)}}
@keyframes ppSpin{to{transform:rotate(360deg)}}
@keyframes ppFloat{50%{transform:translateY(-12px)}}

@media(max-width:960px){
  .pp{padding:120px 18px 70px}
  .pp-in{flex-direction:column;gap:64px}
  .pp-text{max-width:100%}
  .pp-vis{width:100%;max-width:420px}
  .pp-chipf.c1{left:-8px}.pp-chipf.c2{right:-8px}
}
@media(max-width:600px){.pp h1{font-size:30px}}
@media(prefers-reduced-motion:reduce){
  .pp *,.pp *::before,.pp *::after{animation:none!important;transition:none!important}
}
`;

const ProductPage = () => {
  const history = useHistory();
  const tiltRef = useRef<HTMLDivElement | null>(null);

  const handleMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = tiltRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const ry = ((e.clientX - r.left) / r.width - 0.5) * 10;
    const rx = ((e.clientY - r.top) / r.height - 0.5) * -10;
    el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`;
  };
  const handleLeave = () => {
    if (tiltRef.current) tiltRef.current.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg)";
  };

  return (
    <div>
      <NavBar />

      {/* hero section */}
      <div className="pp">
        <style>{STYLES}</style>
        <div className="pp-in">
          <div className="pp-text">
            <div className="pp-chip">Product Development</div>
            <h1>Our Product Development And Services</h1>
            <div className="pp-line"><i /><i /></div>

            <p>
              <b>ATUM Information Technology</b> specializes in product development and services designed to
              elevate your business. Our team of experts brings the skills and experience needed to build
              innovative, functional products that strengthen your offerings and drive revenue growth.
            </p>
            <p>
              From initial concept to final launch, we collaborate closely with our clients to ensure every
              product is customised to meet specific business goals. Our solutions are built not just to
              function but to perform, scale, and succeed.
            </p>
            <p>
              With ATUM’s product development services, you get more than just a solution, you get a strategic
              partner in your growth journey. Let us help you bring your vision to life and unlock your next
              phase of success.
            </p>

            <div className="pp-tags">
              {highlights.map((h) => (
                <span className="pp-tag" key={h.title} title={h.note}>{h.title}</span>
              ))}
            </div>

            <button className="pp-btn" onClick={() => history.push("/contact")}>
              Get Started <span>→</span>
            </button>
          </div>

          <div className="pp-vis" onMouseMove={handleMove} onMouseLeave={handleLeave}>
            <div className="pp-ring" />
            <div className="pp-tilt" ref={tiltRef}>
              <img src={productbanner} alt="ATUM product development" />
            </div>
            <div className="pp-chipf c1">
              <span className="dot">✓</span>
              <div>Customised<b>For Your Goals</b></div>
            </div>
            <div className="pp-chipf c2">
              <span className="dot">★</span>
              <div>Built To<b>Scale</b></div>
            </div>
          </div>
        </div>
      </div>

      <OurProducts />
      {/* help Section */}
      <Help />
      <ScrollToTopButton />
      {/* footer section */}
      <Footer />
    </div>
  );
};

export default ProductPage;